import React from 'react';
import { Card, CardSegment } from '../ui';
import ReactMarkdown from 'react-markdown';

const CaptionCardSmall: React.FC<{ caption: string }> = ({ caption }) => (
  <div className="bt b--light-gray tl f7 serif lh-copy">
    <CardSegment className="pv3">
      <ReactMarkdown source={caption} className="markdown-caption" />
    </CardSegment>
  </div>
);

const CaptionCardNotSmall: React.FC<{ caption: string }> = ({ caption }) => (
  <Card className="tl f7 serif lh-copy mb2">
    <CardSegment className="pv4">
      <ReactMarkdown source={caption} className="markdown-caption" />
    </CardSegment>
  </Card>
);

export { CaptionCardSmall, CaptionCardNotSmall };
